export const PROOF_INCOME_PRODUCT_TYPES = {
  PRE_SALE: 'pre_sale',
  RENT: 'rent',
  SALE: 'sale',
};
